module.exports = __webpack_public_path__ + "static/0047-70ef3ae0ed02af1201bb0c3d5e3a179b.png";